<template>
  <div>
    <v-container
        style="max-width: unset; background: #e5e5e5"
    >
      <v-tabs
          v-model="activeTab"
          class="px-0"
          background-color="#ECEEF1"
          grow
          height="55"
          hide-slider
      >
        <v-tab
            :value="0"
            active-class="active-tab"
            class="tab"
            style="font-weight: bold !important"
            @click="activeTab = 0"
        >
          <span>Estoque das revendas</span>
        </v-tab>

        <v-tab
            :value="1"
            active-class="active-tab"
            class="tab"
            @click="activeTab = 1"
        >
          <span>Histórico de estoque das revendas</span>
        </v-tab>
      </v-tabs>

      <v-card
          v-if="activeTab === 0"
          transition="scale-transition"
          class="d-column mt-0 mb-4 py-1"
          elevation="1"
          color="#FFFFFF"
          style="border-radius: 6px"
      >
        <v-row class="pt-3  pb-2 ma-0 justify-space-between">
          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="pa-2"
          >
            <v-text-field
                v-model="filter.product"
                outlined
                placeholder="Digite o Produto"
                label="Produto"
                hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="pa-2"
          >
            <v-text-field
                v-model="filter.sku"
                outlined
                placeholder="Digite o SKU"
                label="SKU"
                hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="pa-2"
          >
            <v-text-field
                v-model="filter.attribute"
                outlined
                placeholder="Digite o atributo"
                label="Atributo"
                hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="pa-2"
          >
            <v-autocomplete
                v-model="filter.resaleIds"
                multiple
                outlined
                item-text="name"
                item-value="id"
                hide-details="auto"
                placeholder="Selecione o revendedor"
                label="Revendedor"
                menu-props="auto"
                :items="resales"
            ></v-autocomplete>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="pa-2"
          >
            <v-autocomplete
                v-model="filter.categoryId"
                item-text="categoryName"
                item-value="categoryId"
                outlined
                placeholder="Selecione a categoria"
                label="Categoria"
                menu-props="auto"
                hide-details="auto"
                :items="categories"
            ></v-autocomplete>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="pa-2"
          >
            <v-autocomplete
                v-model="filter.subcategoryId"
                item-text="name"
                item-value="subCategoryId"
                outlined
                placeholder="Selecione a subcategoria"
                label="Subcategoria"
                menu-props="auto"
                hide-details="auto"
                :items="subcategories"
            ></v-autocomplete>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="px-2"
              style="margin-top: -2px;"
          >
            <v-btn
                outlined
                width="100%"
                style="border-radius: 8px!important;"
                large
                @click="searchStockResale"
            >
              Buscar
            </v-btn>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="3"
              lg="3"
              class="px-2 d-flex justify-space-between"
              style="margin-top: -2px; "
          >
            <v-btn
                outlined
                width="49%"
                style="border-radius: 8px!important;"
                large
                @click="reset"
            >
              Limpar
            </v-btn>

            <v-btn
                outlined
                width="49%"
                style="border-radius: 8px!important;"
                large
                @click="excel"
            >
              Exportar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card
          v-else
          transition="scale-transition"
          class="d-column mt-0 mb-4 py-1"
          elevation="1"
          color="#FFFFFF"
          style="border-radius: 6px"
      >
        <v-row class="pt-3  pb-2 ma-0 justify-space-between">
          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-text-field
                v-model="stockHistoryFilter.product"
                outlined
                placeholder="Digite o Produto"
                label="Produto"
                hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-text-field
                v-model="stockHistoryFilter.sku"
                outlined
                placeholder="Digite o SKU"
                label="SKU"
                hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-text-field
                v-model="stockHistoryFilter.orderId"
                outlined
                placeholder="Digite o n° do pedido"
                label="Pedido"
                hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="pa-2"
          >
            <v-autocomplete
                v-model="stockHistoryFilter.resaleIds"
                multiple
                outlined
                item-text="name"
                item-value="id"
                hide-details="auto"
                placeholder="Selecione o revendedor"
                label="Revendedor"
                menu-props="auto"
                :items="resales"
            ></v-autocomplete>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="px-2"
              style="margin-top: -2px;"
          >
            <v-btn
                outlined
                width="100%"
                style="border-radius: 8px!important;"
                large
                @click="searchForResellerStockHistory"
            >
              Buscar
            </v-btn>
          </v-col>

          <v-col
              cols="12"
              sm="6"
              md="4"
              lg="4"
              class="px-2 d-flex justify-space-between"
              style="margin-top: -2px; "
          >
            <v-btn
                outlined
                width="49%"
                style="border-radius: 8px!important;"
                large
                dense
                @click="resetHistoricoskuLogs"
            >
              Limpar
            </v-btn>

            <v-btn
                outlined
                width="49%"
                style="border-radius: 8px!important;"
                large
                @click="excelHistory"
            >
              Exportar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-tabs-items v-model="activeTab">
        <v-tab-item :value="0" >
          <v-data-table
              :headers="headers"
              :items="items"
              class="content-table"
              loading-text="Buscando..."
              no-data-text="Sem registros"
              hide-default-footer
          >
            <template v-slot:[`item.sku`]="{ item }">
              {{ item.productSku.product.productName }}
              (SKU - {{ item.productSku.sku }})
            </template>

            <template v-slot:[`item.attribute`]="{ item }">
              {{ item.productSku.attributes[0].name }}
            </template>

            <template v-slot:[`item.categories`]="{ item }">
              {{
                item.productSku.product.categories
                    .map((x) => x.category.categoryName)
                    .join(", ")
              }}
            </template>

            <template v-slot:[`item.subcategories`]="{ item }">
              {{
                item.productSku.product.subCategories
                    .map((x) => x.subCategory.name)
                    .join(", ")
              }}
            </template>

            <template v-slot:[`item.productSku.differentValue`]="{ item }">
              {{
                item.productSku.differentValue
                    ? item.productSku.differentValue.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                    : "R$ 0,00"
              }}
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="filter.totalItems > filter.pageSize"
                    :currentPage="filter.currentPage"
                    :totalItems="filter.totalItems"
                    :page="filter.page"
                    :pageSize="filter.pageSize"
                    :totalPages="filter.totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>

        <v-tab-item :value="1">
          <v-data-table
              :headers="historicoskuLogsHeaders"
              :items="historicoskuLogs"
              class="content-table"
              loading-text="Buscando..."
              no-data-text="Sem registros"
              hide-default-footer
          >
            <template v-slot:[`item.sku`]="{ item }">
              {{ item.productSku.productSku.product.productName }} -
              (SKU - {{ item.productSku.productSku.sku }}) -
              (Atributos - {{ item.productSku.productSku.attributes.map(x => x.name).join(', ') }})
            </template>

            <template v-slot:[`item.description`]="{ item }">
              {{ item.description ? item.description : '-' }}
            </template>

            <template v-slot:[`item.orderCode`]="{ item }">
              {{ item.orderCode ? item.orderCode : '-' }}
            </template>

            <template
                v-slot:[`item.actions`]="{ item }"
                cols="12"
                md="6"
                xs="12"
                sm="12"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      outlined
                      fab
                      tile
                      v-if="item.orderId"
                      small
                      class="edit-button"
                      style="border: none"
                      @click="handleRowClick(item.orderId, $event)"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Ver pedido</span>
              </v-tooltip>
            </template>

            <template v-slot:footer class="ma-0 pa-0">
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="stockHistoryFilter.totalItems > stockHistoryFilter.pageSize"
                    :currentPage="stockHistoryFilter.currentPage"
                    :totalItems="stockHistoryFilter.totalItems"
                    :page="stockHistoryFilter.page"
                    :pageSize="stockHistoryFilter.pageSize"
                    :totalPages="stockHistoryFilter.totalPages"
                    @back-page="backPageHistoricoskuLogs"
                    @next-page="nextPageHistoricoskuLogs"
                >
                </Pagination>
              </section>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script lang="js">
import ApiService from '../../../services/ApiService';
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "ResaleStock",
  components: {Pagination},

  created() {
    this.getResales();
    this.getCategories();
    this.getSubCategories();

    const resaleStockTab = JSON.parse(localStorage.getItem("resaleStockTab"));
    this.activeTab = resaleStockTab ? Number(resaleStockTab) : 0

    const resaleStock = JSON.parse(localStorage.getItem("resaleStock"));

    if (resaleStock) {
      this.filter = resaleStock
    }

    const resaleStockHistoric = JSON.parse(localStorage.getItem("resaleStockHistoric"));

    if (resaleStockHistoric) {
      this.stockHistoryFilter = resaleStockHistoric
    }
    this.list()
    this.listHistoricoskuLogs()
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      filters: false,
      activeTab: 0,
      filter: {
        sku: '',
        resaleIds: [],
        categoryId: '',
        subcategoryId: '',
        page: 1,
        pageSize: 10,
        totalPages: 1,
        currentPage: 1,
        totalItems: 1,
      },
      stockHistoryFilter: {
        product: '',
        sku: '',
        orderId: '',
        resaleIds: [],
        page: 1,
        pageSize: 10,
        totalPages: 1,
        currentPage: 1,
        totalItems: 1,
      },
      headers: [
        {
          text: "Revenda",
          value: "resale.name",
          sortable: false,
        },
        {
          text: "SKU",
          value: "sku",
          sortable: false,
        },
        {
          text: "Atributo",
          value: "attribute",
          sortable: false,
        },
        {
          text: "Categorias",
          value: "categories",
          sortable: false,
        },
        {
          text: "Subcategorias",
          value: "subcategories",
          sortable: false,
        },
        {
          text: "Valor",
          value: "productSku.differentValue",
          sortable: false,
        },
        {
          text: "Quantidade",
          value: "quantity",
          sortable: false,
        },
      ],
      historicoskuLogsHeaders: [
        {
          text: "Revenda",
          align: "center",
          value: "productSku.resale.name",
          sortable: false,
        },
        {
          text: "SKU",
          align: "center",
          value: "sku",
          sortable: false,
        },
        {
          text: "Descrição",
          align: "center",
          value: "description",
          sortable: false,
        },
        {
          text: "Quantidade anterior",
          align: "center",
          value: "oldQuantity",
          sortable: false,
        },
        {
          text: "Quantidade atual",
          align: "center",
          value: "newQuantity",
          sortable: false,
        },
        /*{
          text: "Estoque mínimo anterior",
          align: "center",
          value: "oldMinimumStock",
          sortable: false,
        },
        {
          text: "Estoque mínimo atual",
          align: "center",
          value: "newMinimumStock",
          sortable: false,
        },*/
        {
          text: "Pedido",
          align: "center",
          value: "orderCode",
          sortable: false,
        },
        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      items: [],
      historicoskuLogs: [],
      resales: [],
      categories: [],
      subcategories: [],
    }
  },

  methods: {
    getCategories() {
      this.apiService.get("category/list").then((response) => {
        this.categories = response;
      });
    },

    getSubCategories() {
      this.apiService.get("subCategory/listAll").then((response) => {
        this.subcategories = response;
      });
    },

    getResales() {
      this.apiService.get("resale/list").then((response) => {
        this.resales = response;
      });
    },

    reset() {
      this.filter = {
        sku: '',
        resaleIds: [],
        categoryIds: [],
        subcategoryIds: [],
        page: 1
      }
      localStorage.setItem("resaleStock", null);
    },

    async resetHistoricoskuLogs() {
      this.stockHistoryFilter = {
        product: '',
        sku: '',
        orderId: '',
        resaleIds: [],
        page: 1,
        totalPages: 1,
      }
      localStorage.setItem("resaleStockHistoric", null);
    },

    excel() {
      this.loading = true;
      this.apiService
          .post(
              "resaleproductsku/list/stock/excel",
              {...this.filter}
          )
          .then((response) => {
            const excel =
                "data:application/octet-stream;base64," + response.content;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `estoques.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    excelHistory() {
      this.loading = true;
      this.apiService
          .post(
              "skulog/list/excel",
              {...this.filter}
          )
          .then((response) => {
            const excel =
                "data:application/octet-stream;base64," + response.content;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `historicoEstoqueRevendas.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    async searchStockResale() {
      this.filter.page = 1
      localStorage.setItem("resaleStock", JSON.stringify(this.filter));
      await this.list()
    },
    async searchForResellerStockHistory() {
      this.stockHistoryFilter.page = 1
      await this.listHistoricoskuLogs()
      localStorage.setItem("resaleStockHistoric", JSON.stringify(this.stockHistoryFilter));
    },
    async list() {
      this.loading = true;
      this.apiService.post('resaleproductsku/list/stock', this.filter).then((response) => {
        this.items = response.content.data
        this.filter.totalPages = response.content.pager.totalPages
        this.filter.totalItems = response.content.pager.totalItems
        this.filter.currentPage = response.content.pager.currentPage
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },

    async backPage() {
      this.filter.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.list();
    },

    async listHistoricoskuLogs() {
      this.loading = true;
      this.apiService.post('skulog/list', this.stockHistoryFilter).then((response) => {
        this.historicoskuLogs = response.content.data
        this.stockHistoryFilter.totalPages = response.content.pager.totalPages
        this.stockHistoryFilter.totalItems = response.content.pager.totalItems
        this.stockHistoryFilter.currentPage = response.content.pager.currentPage
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },

    async backPageHistoricoskuLogs() {
      this.stockHistoryFilter.page -= 1;
      await this.listHistoricoskuLogs();
    },

    async nextPageHistoricoskuLogs() {
      this.stockHistoryFilter.page += 1;
      await this.listHistoricoskuLogs();
    },

    async handleRowClick(id) {
      localStorage.setItem("resaleStockHistoric", JSON.stringify(this.stockHistoryFilter));
      await this.$router.push({
        path: `/order-detail?id=${id}`,
      });
    },
  },

  watch: {
    "filter.page": {
      deep: true,
      async handler() {
        await this.list()
      }
    },
    "stockHistoryFilter.page": {
      deep: true,
      async handler() {
        await this.listHistoricoskuLogs()
      }
    },
    activeTab() {
      localStorage.setItem("resaleStockTab", JSON.stringify(this.activeTab));
    }
  }
};
</script>

<style scoped>
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}

.tab {
  font-weight: bold;
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

</style>
